(function () {
    'use strict';

    a3_cabin_reports.factory('SafetyReportFactory', SafetyReportFactory);

    function SafetyReportFactory($http, apiUrl) {

        var submitResponseObj = { success: false, message: '' };

        var service = {
            saveSafetyReport: saveSafetyReport,
            saveFatigueReport: saveFatigueReport,
            emailFatigueReport: emailFatigueReport
        };

        function saveSafetyReport(safetyReport) {
            var aqdBaseURL = apiUrl + '/SafetyReports/SaveSafetyReport';
            return $http.post(aqdBaseURL, safetyReport, { 'Content-Type': 'application/json' })
            .then (res => getResponse(res))
            .catch(res => getResponseFailed(res));
        }

        function saveFatigueReport(fatigueReport) {
            var aqdBaseURL = apiUrl + '/SafetyReports/SaveFatigueReport';

            return $http.post(aqdBaseURL, fatigueReport, { 'Content-Type': 'application/json' })
            .then (res => getFatigueResponse(res))
            .catch(res => getResponseFailed(res));
        }

        function getResponse(res) {
            submitResponseObj.success = res.data.success;
            if (res.data.success) {
                submitResponseObj.message = "Safety Report Submited successfully";
            }
            else {
                submitResponseObj.message =  res.data.errorMessage;
            }
            return submitResponseObj;
        }

        function getResponseFailed(res) {
            submitResponseObj.success = false;
            submitResponseObj.message = "Something went wrong!"
            return submitResponseObj;
        }

        function emailFatigueReport(fatigueReport) {
            var aqdBaseURL = apiUrl + '/SafetyReports/EmailFatigueReport';

            return $http.post(aqdBaseURL, fatigueReport, { 'Content-Type': 'application/json' })
                .then(res => getFatigueResponse(res))
                .catch(res => getFatigueResponseFailed(res));
        }

        function getFatigueResponse(res) {
            submitResponseObj.success = res.data.success;
            if (res.data.success) {
                submitResponseObj.message = "Fatigue Report sent successfully.";
            }
            else {
                submitResponseObj.message = res.data.errorMessage;
            }
            return submitResponseObj;
        }

        function getFatigueResponseFailed(res) {
            submitResponseObj.success = false;
            submitResponseObj.message = "Something went wrong!"
            return submitResponseObj;
        }

        return service;
    }
})();